import { css } from '@emotion/core';
import {
  borderStyle,
  minimumWidth,
  pxToRem,
  styled,
  textStyle,
} from '@feast-it/ui/light';

export const StyledInput = styled.input(
  ({ theme }) => css`
    width: 100%;
    height: ${theme.spacing[12]};
    ${borderStyle({ theme, color: 'mediumGrey' })};
    border-radius: ${pxToRem(24)};
    ${textStyle(theme, 'bodyMedium', 'black')};
    padding: 0 ${theme.spacing[4]};
    margin: 0 auto ${theme.spacing[4]};

    ${minimumWidth(theme.breakpoints.small)} {
      max-width: ${pxToRem(360)};
      margin: 0 0 ${theme.spacing[6]};
    }
  `
);
